import { careByEllaTenantConfig } from "@care-by-ella/tenant-care-by-ella";

// Single-tenant build for now. Swap for host-based picking once a second
// tenant lands.
export const TENANT = careByEllaTenantConfig;

// CAR-36: the clinician JWT is no longer stored in the browser. It lives in
// an httpOnly cookie set by the API (`POST /employee-api/v1/session`) and is
// never readable from JS, so there is no storage key here anymore.
